import type { ActionFunction as ActionFunctionType, LoaderFunction as LoaderFunctionType } from '@remix-run/node';

export { createCookieSessionStorage } from '@remix-run/node';

export { installGlobals, json, redirect, replace } from '@remix-run/node';

export type {
  EntryContext,
  LoaderFunction,
  ActionFunction,
  MetaFunction,
  MetaArgs,
  MetaDescriptor,
  LinksFunction,
  TypedResponse,
} from '@remix-run/node';

export type { Params } from '@remix-run/router';
export type LoaderArgs = Parameters<LoaderFunctionType>[0];
export type ActionArgs = Parameters<ActionFunctionType>[0];

export const IgnoredPaymentSystems = ['ECOMMPAY_APPLE', 'ECOMMPAY_GOOGLE'];
